import instance from "../utils/network";

export interface YoutubeLiveResponse {
  id?: number;
  name: string;
  link?: string;
  isLive: boolean;
  imageUrl: string;
  attendeeId: number;
  order?: number;
  pubId?: number;
  tournamentId?: number;
}

export interface YoutubeLiveRequestDto {
  pubId: number;
  name: string;
  link: string;
  isLive: boolean;
  order: number;
}

export interface YoutubeLiveRequest {
  attendeeId: number;
  link: string;
  order: number;
}

export interface YoutubeLiveUpdateAndPushRequest {
  request: YoutubeLiveResponse[];
  title: string;
  pubId: number;
  description: string;
}

export interface YoutubeLivePushRequest {
  tournamentId: number;
  title: string;
  pubId: number;
  description: string;
}

export function getYoutubeLive(pubId: number): Promise<YoutubeLiveResponse[]> {
  return instance.get(`/seller/youtube-live/${pubId}`);
}

export function pushYoutubeList(request: YoutubeLivePushRequest): Promise<any> {
  return instance.put(`/seller/youtube-live/push`, request);
}
